import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';

const Styling = styled.div`
  .st0 {
    display: none;
  }
  .st1 {
    display: inline;
  }
  .st2 {
    display: inline;
    fill: none;
    stroke: #000000;
    stroke-width: 1.5;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-miterlimit: 10;
  }
  .st3 {
    fill: ${({ color, theme }) => color || (theme && theme.iconColor)};
  }
  .st4 {
    display: inline;
    fill: #a28352;
  }
  .st5 {
    fill: #231f20;
  }
  .st6 {
    display: inline;
    fill: #231f20;
  }
  .st7 {
    fill: none;
    stroke: #231f20;
    stroke-width: 1.5;
    stroke-linecap: round;
    stroke-miterlimit: 10;
  }
  .st8 {
    fill: #a28352;
  }
  .st9 {
    display: inline;
    fill: none;
    stroke: #444444;
    stroke-width: 3;
    stroke-linecap: round;
    stroke-miterlimit: 10;
  }
  .st10 {
    display: inline;
    fill: #facb46;
  }
  .st11 {
    display: inline;
    fill: #d0023d;
  }
  .st12 {
    display: inline;
    fill: #335c33;
  }
`;

const TwoWheelSettings = ({ size, iconTitle }) => (
  <Styling>
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width={size}
      height={size}
      viewBox="0 0 30 30"
      xmlSpace="preserve"
    >
      <title>{iconTitle}</title>
      <g id="Layer_1" className="st0">
        <path
          className="st1"
          d="M29.2,23.9c0,0,0-0.1,0-0.1V7.9c0-0.1,0-0.1,0-0.2c0-0.1,0-0.3,0-0.4c-0.1-0.3-0.4-0.5-0.7-0.5H28H2H1.6
		C1.2,6.7,1,6.9,0.9,7.3c0,0.1,0,0.3,0,0.4c0,0.1,0,0.1,0,0.2v15.9c0,0,0,0.1,0,0.1c-0.1,0.3-0.1,0.6,0.2,0.8
		C1.2,25,1.6,25,1.8,24.9c0,0,0.1,0,0.1,0H28c0.1,0,0.1,0,0.1,0c0.3,0.1,0.7,0,0.9-0.2C29.2,24.5,29.3,24.2,29.2,23.9z M20.1,16.8
		l6.6,6.7H3.4l6.6-6.7l-7.6,5.9V8.9l12.3,8.5c0.1,0.1,0.3,0.1,0.4,0.1s0.3,0,0.4-0.1l12.3-8.5v13.8L20.1,16.8z M26,8.2L15,16.3
		L4,8.2H26z"
        />
        <path className="st2" d="M15,12.4" />
      </g>
      <g id="Layer_2" className="st0">
        <path className="st2" d="M15,12.4" />
        <path
          className="st1"
          d="M29.2,23.9c0,0,0-0.1,0-0.1V7.9c0-0.1,0-0.1,0-0.2c0-0.1,0-0.3,0-0.4c-0.1-0.3-0.4-0.5-0.7-0.5H28h-1.5V0.5
		H3.7v6.2H2H1.6C1.2,6.7,1,6.9,0.9,7.3c0,0.1,0,0.3,0,0.4c0,0.1,0,0.1,0,0.2v15.9c0,0,0,0.1,0,0.1c-0.1,0.3-0.1,0.6,0.2,0.8
		C1.2,25,1.6,25,1.8,24.9c0,0,0.1,0,0.1,0H28c0.1,0,0.1,0,0.1,0c0.3,0.1,0.7,0,0.9-0.2C29.2,24.5,29.3,24.2,29.2,23.9z M25.5,1.5
		v7.1L15,16.3L4.7,8.8V1.5H25.5z M14.6,17.4c0.1,0.1,0.3,0.1,0.4,0.1s0.3,0,0.4-0.1l12.3-8.5v13.8l-7.6-5.9l6.6,6.7H3.4l6.6-6.7
		l-7.6,5.9V8.9L14.6,17.4z"
        />
      </g>
      <g id="Layer_3" className="st0">
        <g className="st1">
          <path
            d="M20.5,8.9c-0.4,0-0.8,0.3-0.8,0.8v14c0,0.1-0.1,0.2-0.2,0.2h-9.1c-0.1,0-0.2-0.1-0.2-0.2v-14c0-0.4-0.3-0.8-0.8-0.8
			S8.8,9.3,8.8,9.7v14c0,0.9,0.7,1.7,1.7,1.7h9.1c0.9,0,1.7-0.7,1.7-1.7v-14C21.2,9.3,20.9,8.9,20.5,8.9z"
          />
          <path
            d="M22.2,7h-3.8V6c0-1.3-1-2.3-2.3-2.3h-2.2c-1.3,0-2.3,1-2.3,2.3v1H7.8C7.4,7,7.1,7.3,7.1,7.7s0.3,0.8,0.8,0.8h14.4
			c0.4,0,0.8-0.3,0.8-0.8S22.6,7,22.2,7z M13.1,6c0-0.4,0.4-0.8,0.8-0.8h2.2c0.4,0,0.8,0.4,0.8,0.8v1h-3.8V6z"
          />
          <path d="M17.8,20.4v-9.2c0-0.4-0.3-0.8-0.8-0.8s-0.8,0.3-0.8,0.8v9.2c0,0.4,0.3,0.8,0.8,0.8S17.8,20.8,17.8,20.4z" />
          <path d="M13.8,20.4v-9.2c0-0.4-0.3-0.8-0.8-0.8s-0.8,0.3-0.8,0.8v9.2c0,0.4,0.3,0.8,0.8,0.8S13.8,20.8,13.8,20.4z" />
        </g>
      </g>
      <g id="Layer_7">
        <g>
          <path
            className="st3"
            d="M10.9,19.4c-0.5,0-1.1-0.1-1.7-0.2l-0.5-0.1v-1.8c-0.4-0.1-0.8-0.3-1.2-0.5l-1.3,1.3l-0.4-0.3
			c-0.9-0.6-1.7-1.4-2.4-2.4L3.1,15l1.3-1.3C4.2,13.4,4,13,3.9,12.5H2.1L2,12c-0.1-0.6-0.2-1.1-0.2-1.7c0-0.5,0.1-1.1,0.2-1.7
			l0.1-0.5h1.8C4,7.8,4.2,7.4,4.4,7L3.1,5.7l0.3-0.4c0.6-0.9,1.4-1.7,2.4-2.4l0.4-0.3l1.3,1.3c0.4-0.2,0.8-0.4,1.2-0.5V1.6l0.5-0.1
			c1.2-0.2,2.2-0.2,3.4,0L13,1.6v1.8c0.4,0.1,0.8,0.3,1.2,0.5l1.3-1.3l0.4,0.3c0.9,0.6,1.7,1.4,2.4,2.4l0.3,0.4L17.3,7
			c0.2,0.4,0.4,0.8,0.5,1.2h1.8l0.1,0.5c0.1,0.6,0.2,1.1,0.2,1.7c0,0.5-0.1,1.1-0.2,1.7l-0.1,0.5h-1.8c-0.1,0.4-0.3,0.8-0.5,1.2
			l1.3,1.3l-0.3,0.4c-0.6,0.9-1.4,1.7-2.4,2.4l-0.4,0.3l-1.3-1.3c-0.4,0.2-0.8,0.4-1.2,0.5v1.8l-0.5,0.1
			C11.9,19.3,11.4,19.4,10.9,19.4z M9.9,18c0.7,0.1,1.2,0.1,1.9,0v-1.7l0.5-0.1c0.6-0.1,1.2-0.4,1.7-0.7l0.4-0.3l1.2,1.2
			c0.5-0.4,0.9-0.8,1.3-1.3l-1.2-1.2l0.3-0.4c0.3-0.5,0.6-1.1,0.7-1.7l0.1-0.5h1.7c0-0.3,0.1-0.6,0.1-0.9c0-0.3,0-0.6-0.1-0.9h-1.7
			l-0.1-0.5c-0.1-0.6-0.4-1.2-0.7-1.7l-0.3-0.4L17,5.6c-0.4-0.5-0.8-0.9-1.3-1.3l-1.2,1.2L14,5.2c-0.5-0.3-1.1-0.6-1.7-0.7l-0.5-0.1
			V2.7c-0.7-0.1-1.2-0.1-1.9,0v1.7L9.4,4.5C8.8,4.6,8.2,4.9,7.7,5.2L7.3,5.5L6.1,4.3C5.6,4.6,5.1,5.1,4.8,5.6L6,6.8L5.7,7.2
			C5.4,7.7,5.1,8.3,5,8.9L4.9,9.4H3.2c0,0.3-0.1,0.6-0.1,0.9c0,0.3,0,0.6,0.1,0.9h1.7L5,11.8c0.1,0.6,0.4,1.2,0.7,1.7L6,13.9
			l-1.2,1.2c0.4,0.5,0.8,0.9,1.3,1.3l1.2-1.2l0.4,0.3c0.5,0.3,1.1,0.6,1.7,0.7l0.5,0.1V18z M10.9,13.7c-1.8,0-3.3-1.5-3.3-3.3
			S9,7,10.9,7c1.8,0,3.3,1.5,3.3,3.3S12.7,13.7,10.9,13.7z M10.9,8.3c-1.1,0-2.1,0.9-2.1,2.1s0.9,2.1,2.1,2.1s2.1-0.9,2.1-2.1
			S12,8.3,10.9,8.3z"
          />
        </g>
        <g>
          <path
            className="st3"
            d="M22.5,28.3l-0.4-1.1c-0.3,0-0.6,0-0.9,0l-0.5,1.1l-0.3-0.1c-0.4-0.1-0.8-0.2-1.1-0.4c-0.3-0.1-0.6-0.3-1-0.6
			L18,27l0.5-1.1c-0.2-0.2-0.4-0.4-0.6-0.7l-1.1,0.4l-0.2-0.3c-0.4-0.7-0.7-1.4-0.8-2.1l0-0.3l1.1-0.4c0-0.3,0-0.6,0-0.9L15.9,21
			l0.1-0.3c0.1-0.4,0.2-0.8,0.4-1.1c0.2-0.3,0.3-0.6,0.6-1l0.2-0.3l1.1,0.5c0.2-0.2,0.4-0.4,0.7-0.6l-0.4-1.1l0.3-0.2
			c0.7-0.4,1.4-0.7,2.1-0.8l0.3,0l0.4,1.1c0.3,0,0.6,0,0.9,0l0.5-1.1l0.3,0.1c0.4,0.1,0.7,0.2,1.1,0.4c0.3,0.2,0.6,0.3,1,0.6
			l0.3,0.2l-0.5,1.1c0.2,0.2,0.4,0.4,0.6,0.7l1.1-0.4l0.2,0.3c0.4,0.7,0.6,1.4,0.8,2.1l0,0.3L26.7,22c0,0.3,0,0.6,0,0.9l1.1,0.5
			l-0.1,0.3c-0.1,0.4-0.2,0.7-0.4,1.1c-0.2,0.3-0.3,0.6-0.6,1L26.6,26l-1.1-0.5c-0.2,0.2-0.4,0.4-0.7,0.6l0.4,1.1l-0.3,0.2
			c-0.7,0.4-1.4,0.7-2.1,0.8L22.5,28.3z M22.6,26.3l0.4,1.1c0.5-0.1,0.9-0.3,1.3-0.5l-0.4-1.1l0.2-0.2c0.4-0.2,0.7-0.5,1-0.9
			l0.2-0.2l1,0.5c0.1-0.2,0.2-0.4,0.3-0.6c0.1-0.2,0.2-0.4,0.2-0.6l-1-0.5l0.1-0.3c0.1-0.4,0.1-0.9,0.1-1.3l0-0.3l1.1-0.4
			c-0.1-0.4-0.3-0.9-0.5-1.3l-1.1,0.4l-0.2-0.2c-0.2-0.4-0.5-0.7-0.9-1l-0.2-0.2l0.5-1c-0.2-0.1-0.4-0.2-0.6-0.3
			c-0.2-0.1-0.4-0.2-0.6-0.2l-0.5,1l-0.3-0.1c-0.4-0.1-0.9-0.1-1.3-0.1l-0.3,0L20.7,17c-0.5,0.1-0.9,0.3-1.3,0.5l0.4,1.1l-0.2,0.2
			c-0.4,0.2-0.7,0.5-1,0.9l-0.2,0.2l-1-0.5c-0.1,0.2-0.2,0.4-0.3,0.6c-0.1,0.2-0.2,0.4-0.2,0.6l1,0.5l-0.1,0.3
			c-0.1,0.4-0.1,0.9-0.1,1.3l0,0.3l-1.1,0.4c0.1,0.5,0.3,0.9,0.5,1.3l1.1-0.4l0.2,0.2c0.2,0.4,0.5,0.7,0.9,1l0.2,0.2l-0.5,1
			c0.2,0.1,0.4,0.2,0.6,0.3c0.2,0.1,0.4,0.2,0.6,0.2l0.5-1l0.3,0.1c0.4,0.1,0.9,0.1,1.3,0.1L22.6,26.3z M21.8,24.4
			c-0.3,0-0.6-0.1-0.9-0.2c-1.1-0.5-1.6-1.8-1.1-2.9c0.3-0.5,0.7-0.9,1.3-1.1c0.6-0.2,1.2-0.2,1.7,0.1c0.5,0.3,0.9,0.7,1.1,1.3
			c0.2,0.6,0.2,1.2-0.1,1.7c-0.2,0.5-0.7,0.9-1.3,1.1C22.3,24.4,22.1,24.4,21.8,24.4z M21.8,20.8c-0.6,0-1.1,0.3-1.3,0.8
			c-0.3,0.7,0,1.6,0.7,2h0c0.4,0.2,0.8,0.2,1.1,0c0.4-0.1,0.7-0.4,0.8-0.8c0.2-0.4,0.2-0.8,0-1.1c-0.1-0.4-0.4-0.7-0.8-0.8
			C22.3,20.8,22,20.8,21.8,20.8z"
          />
        </g>
      </g>
      <g id="Layer_4" className="st0">
        <path
          className="st4"
          d="M-4.3-18.8c-13.6,0-24.6,11-24.6,24.6s11,24.6,24.6,24.6s24.6-11,24.6-24.6S9.3-18.8-4.3-18.8z M-8.7,14.3
		c-1.5,0-2.9,0-4.4,0c0-4.4,0-8.7,0-13.1c1.4,0,2.9,0,4.4,0C-8.7,5.5-8.7,9.9-8.7,14.3z M-9.4-1c-1.1,0.7-3.5,0.6-3.9-1.4
		c0-0.1-0.1-0.1-0.1-0.2c0-0.3,0-0.6,0-0.8c0.9-1.8,2.5-2.4,3.9-1.6C-8.1-4.1-8-1.9-9.4-1z M6.9,14.3c-0.7,0-1.4,0-2.1,0
		c-0.7,0-1.4,0-2.2,0c0-0.3,0-0.6,0-0.9c0-2.3,0-4.6-0.1-6.9C2.4,5.1,1.6,4.3,0.3,4.3c-1.3,0-2.3,1.1-2.3,2.4c0,2.5,0,4.9,0,7.5
		c-1.5,0-2.9,0-4.4,0c0-4.4,0-8.7,0-13.1c1.5,0,2.9,0,4.4,0c0,0.5,0,1,0,1.6c0.8-1,1.6-1.6,2.7-1.9c3.1-0.7,5.8,1.1,6.1,4.4
		C7.1,8.2,6.9,11.2,6.9,14.3z"
        />
      </g>
      <g id="Layer_6" className="st0">
        <g className="st1">
          <path
            className="st5"
            d="M15,28.4c-7.4,0-13.4-6-13.4-13.4S7.6,1.6,15,1.6s13.4,6,13.4,13.4S22.4,28.4,15,28.4z M15,3.1
			C8.4,3.1,3.1,8.4,3.1,15S8.4,26.9,15,26.9S26.9,21.6,26.9,15S21.6,3.1,15,3.1z"
          />
        </g>
        <path
          className="st6"
          d="M24.6,12.8c-0.1-0.4-0.5-0.7-0.9-0.6L15.8,14c-0.2-0.2-0.5-0.3-0.8-0.3c-0.7,0-1.3,0.6-1.3,1.3
		c0,0.1,0,0.1,0,0.2L9,20.3c-0.3,0.3-0.3,0.8,0,1.1c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.5-0.2l4.8-5.1c0,0,0.1,0,0.1,0
		c0.5,0,1-0.3,1.2-0.8l7.9-1.8C24.4,13.6,24.7,13.2,24.6,12.8z"
        />
        <g className="st1">
          <path className="st7" d="M42.9,18.3" />
        </g>
      </g>
      <g id="Layer_5" className="st0">
        <path
          className="st4"
          d="M-3.9-18.8c-13.6,0-24.6,11-24.6,24.6s11,24.6,24.6,24.6s24.6-11,24.6-24.6S9.7-18.8-3.9-18.8z M2.9-3.6H0.5
		c-2,0-2.3,1.2-2.3,2.5v2.8h4.7L2.2,7h-4.1v11.8h-4.7V7h-4.1V1.7h4.1v-3.2c0-4.1,2.3-6.3,5.9-6.3c1.7,0,2.9,0.1,3.5,0.2V-3.6z"
        />
      </g>
      <g id="Layer_8" className="st0">
        <g className="st1">
          <path
            className="st8"
            d="M104.6,21.3H17.4v-49.9h87.2V21.3z M21.9,16.9h78.3v-41H21.9V16.9z"
          />
        </g>
        <g className="st1">
          <path
            className="st8"
            d="M61,12.9c-9.1,0-16.6-7.4-16.6-16.6c0-9.1,7.4-16.6,16.6-16.6s16.6,7.4,16.6,16.6C77.6,5.5,70.1,12.9,61,12.9
			z M61-18c-7.9,0-14.3,6.4-14.3,14.3c0,7.9,6.4,14.3,14.3,14.3S75.4,4.3,75.4-3.6C75.4-11.6,68.9-18,61-18z"
          />
        </g>
        <g className="st1">
          <rect x="27.3" y="-19.7" className="st8" width="9" height="2.2" />
        </g>
        <g className="st1">
          <rect x="87.2" y="-19.7" className="st8" width="9" height="2.2" />
        </g>
        <g className="st1">
          <rect x="27.3" y="10.7" className="st8" width="9" height="2.2" />
        </g>
        <g className="st1">
          <rect x="87.2" y="10.7" className="st8" width="9" height="2.2" />
        </g>
        <g className="st1">
          <polygon
            className="st8"
            points="-62.5,-14.2 -60,-14.2 -60,-21.6 -52.6,-21.6 -52.6,-24.1 -60,-24.1 -60,-31.5 -62.5,-31.5
			-62.5,-24.1 -69.9,-24.1 -69.9,-21.6 -62.5,-21.6 		"
          />
          <polygon
            className="st8"
            points="-56,0.9 -61.2,6.1 -66.5,0.9 -68.2,2.6 -63,7.9 -68.2,13.1 -66.5,14.8 -61.2,9.6 -56,14.8
			-54.2,13.1 -59.5,7.9 -54.2,2.6 		"
          />

          <rect
            x="-42.9"
            y="6.6"
            transform="matrix(0.707 -0.7072 0.7072 0.707 -15.5724 -21.8866)"
            className="st8"
            width="17.3"
            height="2.5"
          />
          <rect x="-42.9" y="-24.1" className="st8" width="17.3" height="2.5" />
          <path
            className="st8"
            d="M-84.2-42.5v72.1h72.1v-72.1H-84.2z M-17,24.7h-62.3v-62.3H-17V24.7z"
          />
          <circle className="st8" cx="-39.5" cy="2.5" r="2.1" />
          <path
            className="st8"
            d="M-28.7,11.4c-1.1,0-1.9,0.9-1.9,1.9c0,1.1,0.9,1.9,1.9,1.9c1.1,0,1.9-0.9,1.9-1.9
			C-26.8,12.2-27.7,11.4-28.7,11.4z"
          />
        </g>
        <g className="st1">
          <polygon
            className="st8"
            points="-123.9,24.7 -123.9,19.4 -126.3,19.4 -126.3,24.7 -133.7,24.7 -133.7,19.4 -136.1,19.4 -136.1,24.7
			-143.5,24.7 -143.5,19.4 -146,19.4 -146,24.7 -153.4,24.7 -153.4,19.4 -155.8,19.4 -155.8,24.7 -163.2,24.7 -163.2,19.4
			-165.6,19.4 -165.6,24.7 -177.6,24.7 -177.6,14.2 -173.3,14.2 -173.3,11.7 -177.6,11.7 -177.6,4.3 -173.3,4.3 -173.3,1.9
			-177.6,1.9 -177.6,-5.5 -173.3,-5.5 -173.3,-7.9 -177.6,-7.9 -177.6,-15.3 -173.3,-15.3 -173.3,-17.8 -177.6,-17.8 -177.6,-25.1
			-173.3,-25.1 -173.3,-27.6 -177.6,-27.6 -177.6,-40.1 -182.5,-40.1 -182.5,29.6 -112.8,29.6 -112.8,24.7 		"
          />
          <path
            className="st8"
            d="M-155.2-11.9h-10.2v26h10.2V-11.9z M-157.7,11.7h-5.3V-9.4h5.3V11.7z"
          />
          <path
            className="st8"
            d="M-138.7-29.1h-10.2v43.2h10.2V-29.1z M-141.2,11.7h-5.3v-38.3h5.3V11.7z"
          />
          <path
            className="st8"
            d="M-122.2-19.2h-10.2v33.4h10.2V-19.2z M-124.7,11.7h-5.3v-28.5h5.3V11.7z"
          />
        </g>
        <g className="st1">
          <path
            className="st8"
            d="M-215.2,15.6v-48h-23.4l0,0l-11-7.7l-11,7.7l0,0H-284v48h33.6v11.1h-8.4V30h18.5v-3.3h-8.4V15.6H-215.2z
			 M-249.6-38.2l8.3,5.8h-16.6L-249.6-38.2z M-279.9-28.3h60.5v39.7h-60.5V-28.3z"
          />
          <path
            className="st8"
            d="M-244.9-22.5l-0.8,0.2c-3.5,1-6.1,3.9-6.8,7.4l-0.1,0.8l10.6,2.7L-244.9-22.5z M-246-20.4l1.7,6.7l-6.4-1.6
			C-250-17.6-248.3-19.5-246-20.4z"
          />
          <path
            className="st8"
            d="M-238.5-20.9c-0.8,0-1.6,0.1-2.5,0.3l0,0l-0.6,0.2c-0.3,0.1-0.7,0.2-1,0.3c0,0,0,0,0,0c0,0,0,0,0,0l0.3,0.7
			l0,0l2.7,10.5l-10.8-2.8l-0.2,0.9c0,0,0,0,0,0l0,0c-0.1,0.8-0.2,1.5-0.2,2.2c0,6.8,5.5,12.3,12.3,12.3c6.8,0,12.3-5.5,12.3-12.3
			S-231.7-20.9-238.5-20.9z M-238.5,2c-5.9,0-10.6-4.8-10.6-10.6c0-0.3,0-0.7,0.1-1l11.7,3l-3.2-12.4c0.7-0.1,1.4-0.2,2-0.2
			c5.9,0,10.6,4.8,10.6,10.6S-232.6,2-238.5,2z"
          />
          <rect x="-272.9" y="-16.9" className="st8" width="15.8" height="1.6" />
          <rect x="-272.9" y="-10.3" className="st8" width="12.5" height="1.6" />
          <rect x="-272.9" y="-3.7" className="st8" width="7.6" height="1.6" />
        </g>
      </g>
      <g id="simi" className="st0">
        <g className="st1">
          <path
            d="M18.5,2.7h-7.1C9.9,2.7,8.6,4,8.6,5.6v19.1c0,1.6,1.3,2.9,2.9,2.9h7.1c1.6,0,2.9-1.3,2.9-2.9V5.6
			C21.4,4,20.1,2.7,18.5,2.7z M10.1,7.8h9.9v13.8h-9.9V7.8z M11.5,4.2h7.1c0.8,0,1.4,0.6,1.4,1.4v1.2h-9.9V5.6
			C10.1,4.8,10.7,4.2,11.5,4.2z M18.5,26.1h-7.1c-0.8,0-1.4-0.6-1.4-1.4v-2.1h9.9v2.1C19.9,25.5,19.3,26.1,18.5,26.1z"
          />
        </g>
        <g className="st1">
          <path
            d="M15,25.2c-0.5,0-0.8-0.4-0.9-0.8l0,0c0-0.5,0.3-0.9,0.8-0.9c0.2,0,0.5,0.1,0.6,0.2c0.2,0.2,0.3,0.4,0.3,0.6
			C15.9,24.8,15.6,25.2,15,25.2C15,25.2,15,25.2,15,25.2z M14.6,24.4c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4
			c0-0.1-0.1-0.2-0.1-0.3S15.1,24,15,24C14.8,24,14.6,24.2,14.6,24.4L14.6,24.4z"
          />
        </g>
      </g>
      <g id="hus" className="st0">
        <g className="st1">
          <path
            d="M25.9,27.8h-9.1v-8h-3.6v8H4.1V16.4L1,14.8L15,2.5l14,12.3l-3.1,1.5V27.8z M18.6,26h5.6V15.3l1.7-0.8L15,4.9L4.2,14.4
			l1.7,0.8V26h5.6v-8h7.1V26z"
          />
        </g>
      </g>
      <g id="las" className="st0">
        <path
          className="st1"
          d="M24.8,12.8h-1.3V9.3c0-4.7-3.8-8.4-8.4-8.4S6.6,4.6,6.6,9.3v3.6H5.2c-0.9,0-1.6,0.7-1.6,1.6v13.1
		c0,0.9,0.7,1.6,1.6,1.6h19.6c0.9,0,1.6-0.7,1.6-1.6V14.4C26.4,13.6,25.7,12.8,24.8,12.8z M8.4,9.3c0-3.6,3-6.6,6.6-6.6
		s6.6,3,6.6,6.6v3.6H8.4V9.3z M24.5,27.3h-19V14.7h1.1h16.9h1.1V27.3z"
        />
        <path
          className="st1"
          d="M16.8,19.2c0-1-0.8-1.8-1.8-1.8s-1.8,0.8-1.8,1.8c0,0.7,0.4,1.2,0.9,1.5l-0.9,3.4h3.5l-0.8-3.4
		C16.4,20.4,16.8,19.9,16.8,19.2z"
        />
      </g>
      <g id="quit" className="st0">
        <g className="st1">
          <path
            d="M15.5,28.6c-7,0-12.7-5.7-12.7-12.7c0-4.6,2.5-8.9,6.6-11.2l1,1.7c-3.4,1.9-5.5,5.5-5.5,9.4c0,5.9,4.8,10.7,10.7,10.7
			c5.9,0,10.7-4.8,10.7-10.7c0-3.8-2.1-7.4-5.4-9.3l1-1.7c3.9,2.3,6.4,6.5,6.4,11C28.3,22.9,22.5,28.6,15.5,28.6z"
          />
        </g>
        <g className="st1">
          <rect x="14.5" y="2.6" width="2" height="12.4" />
        </g>
      </g>
      <g id="pdf" className="st0">
        <g id="Layer_2_1_" className="st1">
          <g id="Layer_1-2">
            <g id="Layer_1-3">
              <g id="Layer_2-2">
                <g id="Layer_1-2-2">
                  <g id="Layer_3_1_">
                      <polygon
                        className="st8"
                        points="20.5,22.9 20.5,25 5.8,25 5.8,5 17.1,5 17.1,8.3 20.5,8.3 20.5,12.2 21.8,12.2 21.8,7.6
								17.8,3.7 4.4,3.7 4.4,26.3 21.8,26.3 21.8,22.9 							"
                      />
                      <path
                        className="st8"
                        d="M12,16.2c-0.3,0-0.4,0-0.4,0.1v1.5H12c0.6,0,1-0.3,1-0.8S12.6,16.2,12,16.2z"
                      />
                      <path
                        className="st8"
                        d="M16.5,16.2c-0.3,0-0.4,0-0.5,0.1v3.3h0.4c0.8,0.1,1.6-0.5,1.7-1.3c0-0.1,0-0.1,0-0.2v-0.3
								c0.1-0.8-0.5-1.5-1.3-1.6c0,0,0,0,0,0H16.5z"
                      />
                      <path
                        className="st8"
                        d="M7.6,13v9h17.9v-9L7.6,13z M13.6,18.1c-0.5,0.4-1.1,0.6-1.7,0.5h-0.3v1.8h-1.2v-5.1
								c0.5-0.1,1-0.1,1.5-0.1c0.5,0,1.1,0.1,1.5,0.4c0.4,0.3,0.6,0.7,0.6,1.2C14.2,17.3,14,17.8,13.6,18.1z M18.5,19.8
								c-0.7,0.5-1.6,0.7-2.4,0.6c-0.6,0-1-0.1-1.3-0.1v-5c0.5-0.1,1-0.1,1.5-0.1c0.7-0.1,1.5,0.2,2.1,0.6c0.6,0.4,0.9,1.2,0.8,1.9
								C19.5,18.5,19.2,19.3,18.5,19.8z M23.2,16.2h-2v1.2h1.9v1h-1.9v2H20v-5.1h3.1L23.2,16.2z"
                      />
                    </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <line className="st9" x1="-94.1" y1="-117" x2="-74.8" y2="-97.7" />
        <line className="st9" x1="-74.8" y1="-117" x2="-94.1" y2="-97.7" />
      </g>
      <g id="new_window" className="st0">
        <g className="st1">
          <path
            className="st8"
            d="M22.7,26.6H3.5V7.4h6.6c0.6,0,1,0.4,1,1s-0.4,1-1,1H5.5v15.2h15.2v-4.9c0-0.6,0.4-1,1-1s1,0.4,1,1V26.6z"
          />
        </g>
        <path
          className="st4"
          d="M14.9,8.3L14.9,8.3C15,8.7,15.3,9,15.7,9l3.9,0l-7.4,7.6c-0.3,0.3-0.3,0.8,0,1.1c0.2,0.1,0.3,0.2,0.5,0.2
		c0.2,0,0.4-0.1,0.6-0.2l7.5-7.6l0.1,3.9c0,0.4,0.4,0.7,0.8,0.8h0c0.5,0,0.8-0.4,0.8-0.8l-0.1-6.7l-6.7,0.1
		C15.3,7.5,14.9,7.8,14.9,8.3z"
        />
      </g>
      <g id="Layer_15" className="st0">
        <g className="st1">
          <path className="st8" d="M26.2,25.1h-22V5.8h22V25.1z M6.3,23.1h18V7.8h-18V23.1z" />
        </g>
        <circle className="st4" cx="20" cy="12.1" r="1.3" />
        <polygon className="st4" points="12.8,12.9 16.6,17.8 18.3,16.4 22.1,20.7 7.8,20.7 	" />
      </g>
      <g id="Layer_15_copy" className="st0">
        <g className="st1">
          <path
            className="st8"
            d="M23.2,5.8V2.8h-2v2.9h-12V2.8h-2v2.9h-3v19.3h22V5.8H23.2z M24.2,23.1h-18V7.8h18V23.1z"
          />
          <rect x="9" y="12.8" className="st8" width="2.7" height="2.7" />
          <rect x="14" y="12.8" className="st8" width="2.7" height="2.7" />
          <rect x="19" y="12.8" className="st8" width="2.7" height="2.7" />
          <rect x="9" y="17.8" className="st8" width="2.7" height="2.7" />
          <rect x="14" y="17.8" className="st8" width="2.7" height="2.7" />
          <rect x="19" y="17.8" className="st8" width="2.7" height="2.7" />
        </g>
      </g>
      <g id="upphropun" className="st0">
        <path
          className="st10"
          d="M15,19.6L15,19.6c-0.7,0-1.3-0.5-1.4-1.2L12.2,4.6c-0.1-1.7,1.2-3.1,2.9-3.1h0c1.7,0,3,1.4,2.9,3.1l-1.6,13.8
		C16.3,19.1,15.7,19.6,15,19.6z"
        />
        <circle className="st10" cx="15.1" cy="25.9" r="2.6" />
      </g>
      <g id="x" className="st0">
        <path
          className="st11"
          d="M17.6,14.7l10-10c0.8-0.8,0.8-2,0-2.8c-0.8-0.8-2-0.8-2.8,0l-10,10l-10-10c-0.8-0.8-2-0.8-2.8,0
		c-0.8,0.8-0.8,2,0,2.8l10,10l-10,10c-0.8,0.8-0.8,2,0,2.8c0.4,0.4,0.9,0.6,1.4,0.6s1-0.2,1.4-0.6l10-10l10,10
		c0.4,0.4,0.9,0.6,1.4,0.6s1-0.2,1.4-0.6c0.8-0.8,0.8-2,0-2.8L17.6,14.7z"
        />
      </g>
      <g id="Layer_19" className="st0">
        <g className="st1">
          <path
            className="st8"
            d="M20.5,4.4h-11c-2.8,0-5.1,2.3-5.1,5.1v11c0,2.8,2.3,5.1,5.1,5.1h11c2.8,0,5.1-2.3,5.1-5.1v-11
			C25.6,6.7,23.3,4.4,20.5,4.4z M23.6,20.5c0,1.7-1.4,3.1-3.1,3.1h-11c-1.7,0-3.1-1.4-3.1-3.1v-11c0-1.7,1.4-3.1,3.1-3.1h11
			c1.7,0,3.1,1.4,3.1,3.1V20.5z"
          />
          <polygon
            className="st8"
            points="16,10.9 14,10.9 14,14 10.9,14 10.9,16 14,16 14,19.1 16,19.1 16,16 19.1,16 19.1,14 16,14 		"
          />
        </g>
      </g>
      <g id="Layer_20" className="st0">
        <path
          className="st12"
          d="M26.4,6.1l-3.9-3.9c-0.6-0.6-1.7-0.6-2.3,0L5.9,16.7l-1.5,7.7l7.7-1.5L26.4,8.4c0.3-0.3,0.5-0.7,0.5-1.1
		C26.9,6.8,26.7,6.4,26.4,6.1z M11.2,21.2L8,21.8l-1.2-1.2l0.6-3.2L18.7,6.3l1.6,1.6L9.6,18.6l0.5,0.5L20.8,8.4l1.5,1.5L11.2,21.2z
		 M22.9,9.4l-3.7-3.7l2.2-2.2l3.7,3.7L22.9,9.4z"
        />
      </g>
    </svg>
  </Styling>
);

TwoWheelSettings.propTypes = {
  iconTitle: PropTypes.string,
  size: PropTypes.number,
};

TwoWheelSettings.defaultProps = {
  iconTitle: null,
  size: 26,
};

export default withTheme(TwoWheelSettings);
